import "./App.css";
import Header from "./Components/Header";

const App = () => {
	return (
		<>
			<Header />
		</>
	);
};

export default App;
